const locales = {
  "ja": {
    "tour_mae_maas_link" : "Mae MaaSに戻る",
    "tour_copyright_first" : "",
    "tour_copyright" : "Powered by JR東日本",
    "tour_back" : "戻る",
    "tour_pass_benefit" : "パス特典",
    "tour_shop_information" : "詳細情報",
    "tour_tolocca" : "To Locca",
    "tour_times_carshare" : "タイムズカーシェア",
    "tour_location" : "所在地",
    "tour_tel" : "電話番号",
    "tour_holiday" : "定休日",
    "tour_website": "詳しく見る",
    "tour_station": "最寄駅",
    "tour_busstop": "最寄バス停",
    "tour_parking": "駐車場",
    "tour_model_course" : "この施設のおすすめコース",
    "tour_business_hours" : "営業時間",
    "tour_nearest_station" : "最寄駅",
    "tour_nearest_busstop" : "最寄バス停",
    "tour_cancel" : "キャンセル",
    "tour_map_location_error_msg" : "現在地情報を取得できませんでした。お使いのブラウザでは現在地情報を利用できない可能性があります。エリアを入力してください。",
    "tour_map_denied_err_msg" : "位置情報の利用が許可されていません",
    "tour_map_position_err_msg" : "現在位置が取得できませんでした",
    "tour_map_timeout_error_message" : "タイムアウトになりました",
    "tour_map_default_error_message" : "現在位置が取得できませんでした",
    "tour_filter_title" : "フィルタ",
    "tour_genre_title" : "カテゴリー",
    "tour_search_place" : "近くのおすすめスポットを表示",
    "tour_duration_label" : "{label}から往復で約{duration}分",
    "tour_duration_before_label" : "前の予定",
    "tour_duration_current_label" : "今",
    "tour_map_search_placeholder" : "現在地",
    "tour_genre_list_link" : "カテゴリ一覧",
    "tour_login_error_message" : "<p>この操作をするにはログインが必要です。<br>まだ会員登録がお済みでない方は、<br>新規会員登録をしてください</p>",
    "tour_plan_label" : "旅行プラン",
    "tour_map_label" : "マップ",
    "tour_present_location" : "現在地",
    "tour_demachiyanagi_station" : "出町柳駅",
    "tour_filter_all_on" : "すべてオン",
    "tour_filter_all_off" : "すべてオフ",
    "tour_close_label" : "閉じる",
    "tour_mobaku_map" : "モバイル空間統計® 人口マップ",
    "tour_mobaku_map_message" : "モバイル空間統計®人口マップは㈱ドコモ・インサイトマーケティングが提供するサービスです",
    "tour_mobaku_map_message2" : "NTTドコモの携帯電話ネットワークの仕組みを利用し、日本の人口を確認できます。",
    "tour_mobaku_map_message3" : "本サービスは集団の人数のみを表す人口統計情報であるため、お客様個人を特定することはできません。",
    "tour_mobaku_web" : "モバイル空間統計®公式サイト",
    "tour_privacy" : "プライバシーポリシー",
    "tour_mobaku_about" : "データ仕様について",
    "tour_google_policy" : "Googleポリシーと規約",
    "tour_about_mobaku" : "モバイル空間統計®について",
    "tour_mae_maas" : "Mae MaaS",
    "tour_place_detail_open": "詳細はこちらをタップ",
    "tour_main_title": "<span class=\"text-brand-secondary\">My</span>プラン",
    "tour_main_description": "おすすめの観光スポット等から簡単に旅行プランを立てられます。<br />目的地を追加・削除すると、自動で移動方法を再検索するので、計画の変更がとても簡単です。",
    "tour_sub_description2": "各施設・店舗の営業情報は、必ずお客さまにてご確認ください",
    "tour_my_plan_section_title": "Myプラン",
    "tour_cources_title": "モデルコース",
    "tour_display_detail_label": "詳細を表示",
    "tour_create_plan_label": "旅行プランを作成する",
    "tour_category_title": "「{genreName}」から旅行プランを作成",
    "tour_add_model_cource_title": "モデルコースをさらに表示する場合はこちらをタップしてください",
    "tour_faq_label": "旅行プランのFAQを見る",
    "tour_maas_top_link": "TOPに戻る",
    "tour_disclaimer_description1": "本サービスは、利用した結果、検索・表示される行程を保証するものではございません。",
    "tour_disclaimer_description2": "本サービスのご利用はお客さまご自身の責任においてご利用ください。",
    "tour_plan_create_title": "旅行プラン作成",
    "tour_departure_time_condition": "出発日時",
    "tour_detail_conditions": "詳細設定",
    "tour_preferred_route_condition": "優先する経路",
    "tour_taxi_condition": "タクシー利用",
    "tour_set_conditions_label": "この条件で設定",
    "tour_departure_label": "出発地",
    "tour_change_departure_label": "出発地を変更",
    "tour_arrival_label": "到着地",
    "tour_change_arrival_label": "到着地を変更",
    "tour_route_label": "経路",
    "tour_minute_label": "分",
    "tour_hour_label": "時間",
    "tour_residence_time_label": "滞在時間",
    "tour_edit_label": "編集",
    "tour_add_destination_label": "目的地を追加",
    "tour_add_destination_from_favorite": "お気に入りから追加",
    "tour_add_destination_from_map": "マップから追加",
    "tour_add_destination_category": "カテゴリーから追加",
    "tour_departure_time_label": "発",
    "tour_arrival_time_label": "着",
    "tour_normal_fare": "通常料金",
    "tour_other_fare": "フリーパス以外の運賃",
    "tour_fare": "運賃",
    "tour_freepass_merit": "フリーパス利用で{price}円お得になります",
    "tour_freepass_link": "フリーパスの詳細はこちら",
    "tour_save_label": "このプランを保存する",
    "tour_back_to_plan_top_label": "プラン選択に戻る",
    "tour_save_success": "を保存しました",
    "tour_buy_ticket": "事前にチケットを購入したい方はこちら",
    "tour_change_label": "変更する",
    "tour_delete_label": "削除する",
    "tour_cory_share_url": "共有URLをコピーする",
    "tour_send_mail": "メールで送る",
    "tour_send_line": "LINEで送る",
    "tour_docomo_share_bike": "ドコモ・バイクシェア",
    "tour_access": "アクセス",
    "tour_add_to_plan": "旅行プランに追加する",
    "tour_about_label": "約",
    "tour_price_with_currency_unit": "{price}<span class=\"text-sm\">円</span>",
    "tour_require_login": "旅行プランの作成には、ログインが必要です。",
    "tour_not_found_plan": "プランが見つかりません。URLが間違っているか、プランが削除された可能性があります",
    "tour_course_label": "コース",
    "tour_plan_link": "作成したプランを表示する",
    "tour_back_to_top": "旅行プラントップへ戻る",
    "tour_setting_departure_label": "出発地設定",
    "tour_setting_arrival_label": "到着地設定",
    "tour_change_arrival_and_stay": "滞在時間を変更",
    "tour_remove_destination": "この目的地を削除",
    "tour_new_place_title": "予定追加",
    "tour_genre_label": "カテゴリー",
    "tour_destination_label": "目的地",
    "tour_add": "追加する",
    "tour_save": "保存する",
    "tour_title_label": "タイトル",
    "tour_require_station": "駅名・バス停名を入力",
    "tour_change_residence_time": "目的地の到着時刻を指定",
    "tour_arrival_time": "開始時刻",
    "tour_setting": "設定する",
    "tour_system_error_message": "システムエラーが発生しました。",
    "tour_not_found_route_message": "指定した予定に到着できる経路が見つかりませんでした。設定を変更するか、追加した予定を削除してください。",
    "tour_not_found_my_plan_message": "現在予定している旅行プランがありません。",
    "tour_not_user_my_plan_message": "旅行プランの作成には、ログインが必要です.",
    "tour_delete_confirm_message": "削除してもよろしいでしょうか？",
    "tour_copied_message": "コピーしました",
    "tour_favorite_label": "お気に入り",
    "tour_remove_label": "削除",
    "tour_taxi_distance_1km": "1km以上の移動のみ",
    "tour_taxi_distance_3km": "3km以上の移動のみ",
    "tour_taxi_distance_none": "利用しない",
    "tour_preferred_free_pass": "フリーパス優先",
    "tour_preferred_ekispert": "早さ優先",
    "tour_total_charge_description": "※運賃に指定席料金が含まれています",
    "tour_get_use_taxi_description": "※上記金額にタクシー代・レンタカー代は含まれません",
    "tour_find_route": "経路を検索する",
    "tour_check_in_category" : "ホテル（DP、旅連）",
    "tour_yen" : "円",
    "tour_login_message" : "※旅行プランの保存にはログインが必要です。",
    "tour_questionnaire_link" : "アンケートにご協力ください",
    "tour_faq_title" : "よくあるご質問",
    "tour_faq_q1" : "旅行プランとはどんなサービスですか？",
    "tour_faq_a1" : "おすすめの観光スポット等から簡単に旅行プランを立てられるサービスです。",
    "tour_faq_q2" : "旅行プランはどのように使えば良いですか？",
    "tour_faq_a2" : "最初に行きたい観光スポットを選ぶだけで簡単にプランを立てられます。旅行前でも旅行中でも、柔軟に目的地を追加・削除したり、滞在時間を変更したりすることが可能です。",
    "tour_faq_q3" : "出発地や目的地は全国のすべての駅やバス停等に対応していますか？",
    "tour_faq_a3" : "出発地や目的地は駅名等を入力した際に表示される駅名等のみに対応しています。表示されない出発地や目的地には対応していません。",
    "tour_platform" : "のりば",
    "tour_checkout_label" : "チェックアウト",
    "tour_checkin_label" : "チェックイン",
    "tour_change_route": "経路の変更",
    "tour_change_route_cancel": "変更をキャンセル",
    "tour_change_route_submit": "この経路に変更"

  },
  "en": {},
  "zh-TW": {}
}

export default locales
